import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Aijentik — AI Agents Built for Real Industries';
render(<App data-id="element-587" />, document.getElementById('root'));